import React, { useState, useCallback, useEffect } from "react";
import { Typography, Box, IconButton, Popover } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { textColor } from "../../../utils/commonstyle";
import Info from "../../../assets/info.png";
import { uploadDocument } from "../../../redux/slice/documentSlice";
import { toast, ToastContainer } from "react-toastify";
import DocumentUploadSection from "./DocumentUploadSection";
import ButtonComponents from "../../commonComponents/ButtonComponents";
import { AppDispatch, RootState } from "../../../redux/store";
import CloseIcon from "@mui/icons-material/Close";
import { getKycDetails } from "../../../redux/slice/ledgerSlice";
import { getRegisterdInvestors, setLoginUserdetails } from "../../../redux/slice/userSlice";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import Loading from "../../Loading";
import { getDocumentType } from "../../../redux/slice/kybSlice";
import ReasonsBox from "../ReasonsBox";


interface FileData {
  files: { file: File; name: string; size: number }[]; type: string;
}

const DocumentVerificationPriority = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const kycDetails = useSelector((state: RootState) => state.ledger.kycDetails)
  const [documentRequired, setDocRequired] = useState(0)
  const { loginInvestorId, loginUserDetails } = useSelector((state: any) => state.user);
  const [documentList, setDocumentList] = useState([])
  const [documentTypes, setDocumentTypes] = useState<any>({ individual: "" });
  const [message, setMessage] = useState<any>({ individual: "" });
  const [files, setFiles] = useState<Record<string, FileData>>({ individual: { files: [], type: "" } });
  const [state, setState] = useState({
    open: false,
    type: "",
    anchorEl: null,
  });

  const { open, type, anchorEl } = state;
  const { instance } = useMsal();
  const msalInstance: any = instance;
  const handleOpen = (event: any, open: boolean, type: any) => {
    setState({ open, type, anchorEl: event.currentTarget });
  };
  const handleClose = () => {
    setState((prev) => ({
      ...prev,
      open: false,
      anchorEl: null,
    }));
  };

  const handleSelectChange = useCallback(
    (event: React.ChangeEvent<{ value: string }>, type: string, ele: any) => {
      const selectedValue = event.target.value;
      console.log(ele)
      setDocRequired(ele.count)
      setMessage((prev: any) => ({
        ...prev,
        [type]: ele.message,
      }));

      setDocumentTypes((prev: any) => ({
        ...prev,
        [type]: ele.value,
      }));

      if (typeof selectedValue === "string") {
        setFiles({
          individual: { files: [], type: "" },
        });
      } else
        setFiles((prev) => ({
          ...prev,
          [type]: {
            ...prev[type],
            type: selectedValue,
          },
        }));
    },
    []
  );

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
    const uploadedFiles = Array.from(event.target.files || []);
    const documentType = documentTypes[type];

    // Limit the number of files
    if (uploadedFiles.length + (files[type]?.files?.length || 0) > 2) {
      toast.error("You can only upload a maximum of 2 files.", {
        className: 'custom-toast'
      });
      event.target.value = ""; // Reset the input
      return;
    }

    // Check file size (10MB = 10 * 1024 * 1024 bytes)
    const maxFileSize = 10 * 1024 * 1024; // 10MB in bytes

    // Define allowed file types
    const allowedFileTypes = ['.jpg', '.jpeg', '.png', '.pdf'];

    for (const file of uploadedFiles) {
      if (file.size > maxFileSize) {
        toast.error(`File size exceeds the 10MB limit.`, {
          className: 'custom-toast'
        });
        event.target.value = ""; // Reset the input
        return;
      }

      // Check file type
      const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
      if (!allowedFileTypes.includes(fileExtension)) {
        toast.error(`File type ${fileExtension} is not allowed. Please upload only ${allowedFileTypes.join(', ')} files.`, {
          className: 'custom-toast'
        });
        event.target.value = '';
        return;
      }
    }

    // Proceed if no file size error
    const updatedFiles = uploadedFiles.map((file) => ({
      file: file,
      name: file.name,
      size: file.size,
    }));

    setFiles((prev) => ({
      ...prev,
      [type]: {
        files: [...(prev[type]?.files || []), ...updatedFiles],
        type: documentType,
      },
    }));

    // Reset the input value to allow selecting the same file again
    event.target.value = "";
  };


  const handleRemoveFile = (type: string, index: number) => {
    setFiles((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        files: prev[type]?.files?.filter((_, i) => i !== index) || [],
      },
    }));
  };

  const handleKycDetails = async () => {
    if (loginInvestorId) {
      try {
        // Wait for 10 seconds before fetching the KYC details
        setTimeout(async () => {
          try {
            // Fetch KYC details after the delay
            const email = msalInstance.getActiveAccount()?.idTokenClaims?.email || sessionStorage.getItem('impersonateEmail') || "";
            const [kycDetailsData, response] = await Promise.all([dispatch(getKycDetails(loginInvestorId)).unwrap(), dispatch(getRegisterdInvestors(email)).unwrap()])
            dispatch(setLoginUserdetails(response.response));

            const checkStatusInterval = setInterval(async () => {
              if (kycDetailsData?.body[0]?.verification_status === "passed") {
                setLoading(false);
                clearInterval(checkStatusInterval);
                navigate("/kyc-kyb/bidding-agreement");
              } else if (kycDetailsData?.body[0]?.kyc_action === "review") {
                navigate(
                  "/kyc-kyb/identity-verification/individual/inprogress-validate"
                );
              } else if (
                (kycDetailsData?.body[0]?.kyc_action === "doc_upload" || kycDetailsData?.body[0]?.kyc_action === "entity_data") &&
                kycDetailsData?.body[0]?.verification_status === "documents_required"
              ) {
                clearInterval(checkStatusInterval);
                setLoading(false);
              } else {
                setLoading(false);
              }
            }, 10000); // Check status every 10 seconds
            setTimeout(() => clearInterval(checkStatusInterval), 30000);

          } catch (error) {
            console.error("Error during KYC details fetch after delay:", error);
          }
        }, 10000); // Delay for 10 seconds before calling the KYC API

      } catch (error) {
        console.error("Error in initial KYC details fetch:", error);
      }
    }
  };

  const handleSubmitDocument = async () => {
    try {
      for (const [_type, fileData] of Object.entries(files)) {
        const { files: filesOfType, type } = fileData;
        setLoading(true);
        if (filesOfType.length > 0) {
          const uploadData: any = {
            InvestorId: loginInvestorId,
            DocumentType: type,
            Description: type,
            FrontFile: filesOfType[0].file,
            BackFile: filesOfType[1] ? filesOfType[1].file : null,
            FileName: filesOfType[0].name || "image",
          };
          const response = await dispatch(uploadDocument(uploadData)).unwrap();
          toast.success(response?.message, {
            className: 'custom-toast'
          });
          navigate("/kyc-kyb/identity-verification/inprogress");
          // Immediately call handleKycDetails to check verification status
          handleKycDetails();
        }
      }

      // Clear fields after submission
      setMessage({
        individual: "",
      });

      setDocumentTypes({
        individual: "",
      });
      setFiles({
        individual: { files: [], type: "" },
      });
    } catch (error) {
      console.error("Error during document submission:", error);
      toast.error("Failed to upload documents", {
        className: 'custom-toast'
      });
    }
  };

  const getDocumentList = async () => {
    const payload = {
      entityType: "Individual"
    }
    const response = await dispatch(getDocumentType(payload)).unwrap()

    const tempResponse = response.map((ele: any) => ({ value: ele.documentTypeCode, label: ele.documentName, message: ele.notes, count: ele.documentCount }))
    console.log(tempResponse);
    setDocumentList(tempResponse)
  }
  useEffect(() => {
    getDocumentList()
  }, [])

  // Check if at least one file has been selected
  const isFormValid =
    documentRequired > 0 &&
    files.individual.files.length === documentRequired &&
    !!documentTypes.individual;

  function getReasons(userHandle: string): string[] {
    if (!kycDetails?.body) return [];
    const lowerCaseUserHandle = userHandle?.toLowerCase()
    for (const verification of kycDetails.body) {
      if (verification?.reasons?.[lowerCaseUserHandle]) {
        console.log(verification.reasons[lowerCaseUserHandle], "verification.reasons[lowerCaseUserHandle]");
        return verification.reasons[lowerCaseUserHandle];
      }
    }

    return [];
  }
  console.log(documentRequired, "documentRequired")
  return (
    <Box
      sx={{
        maxWidth: { xs: "90%", md: "45%" },
        mx: "auto",
        my: 1.5,
        display: "flex",
        flexDirection: "column",
        minHeight: { xs: "80vh", md: "30.2rem" },
        bgcolor: "background.paper",
        overflow: "hidden",
        p: 4,
      }}
    >
      <ToastContainer />
      {loading ? <Loading height="400px" /> :
        <>
          <Typography
            variant="h5"
            sx={{
              fontWeight: "600",
              fontSize: { xs: "1.25rem", md: "1.5rem", xl: "1.625rem" },
              color: textColor.fontColor,
              mb: 2,
              textAlign: "center",
            }}
          >
            Additional Documents Required
          </Typography>

          <Typography
            textAlign="center"
            fontWeight={400}
            fontSize={14}
            color={textColor.primaryFont}
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'break-word', // or 'break-all' for aggressive breaks
            }}
          >
            There seems to be an issue with some details provided for your User
            Identity Verification. Please upload the requested documents to
            continue.
          </Typography>
          <ReasonsBox
            reasons={getReasons(loginUserDetails?.UserHandle)}
          />
          <Box
            ml="auto"
            my={1}
            color="#087CA7"
            fontSize={14}
            display="flex"
            justifyContent="end"
            p={1}
            gap={1}
            onClick={(e) => {
              handleOpen(e, true, "");
            }}
            bgcolor="#DDECFB"
          >
            Document Requirements{" "}
            <img
              src={Info}
              alt="info"
              style={{ height: "16px", width: "16px", margin: "auto" }}
            />
          </Box>

          <Box className="scroll-container overflow-auto">
            <DocumentUploadSection
              count={documentRequired}
              title={``}
              type={`individual`}
              options={documentList}
              documentTypes={documentTypes}
              message={message[`individual`]}
              files={files}
              onSelectChange={handleSelectChange}
              onFileChange={handleFileChange}
              onRemoveFile={handleRemoveFile}
            />
          </Box>

          <div className="flex justify-center mt-6">
            <ButtonComponents
              label="Submit"
              onClick={handleSubmitDocument}
              variant="contained"
              sx={{ fontSize: 14, borderRadius: "9px" }}
              disabled={!isFormValid} // Disable button if no document is uploaded
            />
          </div>
        </>}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: {
              overflow: "visible",
              borderRadius: "8px",
              borderTopLeftRadius: 3,
              paddingX: 2,
              paddingY: 1,
              maxWidth: 300,
              ml: 13,
              mt: 3,
              boxShadow: "3px 3px 5px 2px rgba(0,0,0,0.1)", // Add shadow for depth
              "&:after,&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 8, // Move above the popover
                left: -9, // Align to the left corner with a small margin
                width: 18,
                height: 18,
                backgroundColor: "white", // Match the popover's background
                transform: "rotate(45deg)", // Rotate to form the arrow
                boxShadow: "-3px 3px 5px -2px rgba(0,0,0,0.1)", // Arrow shadow
              },
            },
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            role={"heading"}
            variant="subtitle1"
            fontWeight="500"
            fontSize={16}
            sx={{ color: "#3B3B3B" }}
          >
            Document Requirements
          </Typography>
          <IconButton
            size="small"
            aria-label="close"
            role="button"
            data-testid="CloseIconButton"
            onClick={handleClose}
            sx={{
              padding: 0,
              color: "#3B3B3B",
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <hr />
        <Typography
          variant="body2"
          fontWeight={"400"}
          fontSize={14}
          sx={{
            color: "#3B3B3B",
            marginTop: 1,
          }}
        >
          <ol>
            <li>
              We need to see all four corners of the document, and the business
              name you are verifying must be clearly visible.
            </li>
            <li> Original PDFs are best.</li>
          </ol>
        </Typography>
        <Box display={"flex"} justifyContent={"center"}>
          <ButtonComponents
            label={"Got it"}
            sx={{ fontSize: 14, py: 1, my: 1 }}
            onClick={() => {
              handleClose();
            }}
          />
        </Box>
      </Popover>
    </Box>
  );
};

export default DocumentVerificationPriority;
